/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AIIntegrationScheduleState,
  AIIntegrationScheduleState$inboundSchema,
} from "./aiintegrationschedulestate.js";

/**
 * Sync schedules for one provider integration. Empty when no config is set for the provider.
 */
export type ListAIIntegrationSchedulesResult = {
  /**
   * Organization the schedules belong to.
   */
  organizationId: string;
  /**
   * AI provider identifier.
   */
  provider: string;
  /**
   * Scheduler state for each of the provider's sync schedules.
   */
  schedules: Array<AIIntegrationScheduleState>;
};

/** @internal */
export const ListAIIntegrationSchedulesResult$inboundSchema: z.ZodMiniType<
  ListAIIntegrationSchedulesResult,
  unknown
> = z.pipe(
  z.object({
    organization_id: z.string(),
    provider: z.string(),
    schedules: z.array(AIIntegrationScheduleState$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "organization_id": "organizationId",
    });
  }),
);

export function listAIIntegrationSchedulesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAIIntegrationSchedulesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAIIntegrationSchedulesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAIIntegrationSchedulesResult' from JSON`,
  );
}
